import BaseField from "./BaseField";

export class InputField extends BaseField {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={this.props.Columns}>
                <div className="field text">
                    <label className="" htmlFor={this.props.id}>
                        {this.renderLabelText()}
                    </label>
                    <input id={this.props.id} type="text" className="text form-control" value={this.props.value}
                           placeholder={this.props.Placeholder} required={this.props.Required} onChange={(e) => {
                                this.props.collectData(this.props.id, e.target.value)
                            }} onBlur={(e) => {if(e.target.value !== '') {
                        this.props.trackInput(this.props.Label)
                    }}}/>
                    {this.renderErrorMessage()}
                </div>
            </div>
        )
    }
}

export default InputField;
